import React, { useCallback, useState } from "react";
import { styled } from "@mui/material/styles";
import { TextField, TextFieldProps } from "@mui/material";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const CustomTextField = styled((props: TextFieldProps) => (
  <TextField {...props} />
))(({ theme }) => ({
  "& input[type=number]": {
    "-moz-appearance": "textfield",
  },
  "& input[type=number]::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "& input[type=number]::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  // "& .Mui-error": {
  //   color: '#d32f2f !important',
  // },

  "& .MuiList-root": {
    backgroundColor: theme.palette.mode === "dark" ? '#424242' : '#fff',
  },

  "& .MuiAutocomplete-popper": {
    backgroundColor: theme.palette.mode === "dark" ? '#424242' : '#fff',
    "& .MuiPaper-root": {
      backgroundColor: theme.palette.mode === "dark" ? '#424242' : '#fff',
    },
    "& .MuiAutocomplete-listbox": {
      backgroundColor: theme.palette.mode === "dark" ? '#1e1e1e' : '#fff',
      "& .MuiAutocomplete-option": {
        backgroundColor: theme.palette.mode === "dark" ? '#1e1e1e' : '#fff',
        "&:hover": {
          backgroundColor: theme.palette.mode === "dark" ? '#2f2f2f' : '#f5f5f5',
        },
      },
    },
  },

  "& .MuiInputLabel-root": {
    color: theme.palette.mode === "dark" ? '#fff' : '#000',
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? '#fff' : '#000',
    },
    // "&.Mui-error": {
    //   color: '#d32f2f',
    // },
    "&.Mui-disabled": {
      color: theme.palette.mode === "dark" ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)',
    },
  },

  "& .MuiOutlinedInput-input": {
    padding: "9px 13px",
    fontSize: "1rem",
    color: theme.palette.mode === "dark" ? '#fff' : '#000',
    letterSpacing: "0.5px",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.mode === "dark" ? '#1e1e1e' : '#fff',
    '& fieldset': {
      borderColor: theme.palette.mode === "dark" ? '#fff' : '#000',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.mode === "dark" ? '#fff' : '#000',
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.mode === "dark" ? '#fff' : '#000',
    },
  },
  "& .MuiOutlinedInput-root.Mui-error": {
    '& fieldset': {
      borderColor: '#d32f2f',
    },
  },
  // "& .MuiOutlinedInput-input.Mui-error": {
  //   '& fieldset': {
  //     borderColor: '#d32f2f',
  //     color: "#d32f2f"
  //   },
  // },
  "& .MuiOutlinedInput-input::-webkit-input-placeholder": {
    color: theme.palette.mode === "dark" ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
    opacity: "1",
  },
  "& .MuiOutlinedInput-input::-webkit-autofill": {
    "-webkit-box-shadow": "0 0 0 30px " + (theme.palette.mode === "dark" ? '#1e1e1e' : '#fff') + " inset",
    "-webkit-text-fill-color": theme.palette.mode === "dark" ? '#fff' : '#000',
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.mode === "dark" ? '#fff' : '#000',
    borderRadius: "5px",
  },
  "& .MuiOutlinedInput-input.Mui-disabled": {
    backgroundColor: theme.palette.mode === "dark" ? 'rgba(255, 255, 255, 0.12)' : '#f8f9fb',
    color: theme.palette.mode === "dark" ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)',
  },
  "& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder": {
    color: theme.palette.mode === "dark" ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)',
    opacity: "1",
  },
  "& .MuiFormHelperText-root": {
    color: theme.palette.mode === "dark" ? '#fff' : '#000',
  },
  // "& .MuiFormHelperText-root.Mui-error": {
  //   color: '#d32f2f',
  // },
}));

type IOutlinedTextField = Omit<TextFieldProps, 'error'> & {
  error?: string
}
export const OutlinedTextField = (props: IOutlinedTextField) => {

  return (
    <CustomTextField
      {...props}
      label={props.label}
      sx={{

        "& .MuiOutlinedInput-root": {

          backgroundColor: 'transparent',
          color: '#FFFFFF',
          "& fieldset": {
            borderColor: "#C4C7C4"
          },
          // "&:hover fieldset": {
          //     borderColor: "#FFFFFF"

          // },
          "&.Mui-focused fieldset": {

            // color: "#FFFFFF"
          },

          "& label": {
            color: '#FFFFFF'
          }

        },


        "& .MuiInputLabel-root": {
          // color: '#FFFFFF',
          "&.Mui-focused": {
            // color: '#FFFFFF'
          }
        },
        // "& input[type=number]": {
        //     "-moz-appearance": "textfield",
        // },
        // "& input[type=number]::-webkit-outer-spin-button": {
        //     "-webkit-appearance": "none",
        //     margin: 0,
        // },
        // "& input[type=number]::-webkit-inner-spin-button": {
        //     "-webkit-appearance": "none",
        //     margin: 0,
        // },
        // "& .MuiOutlinedInput-input": {
        //     padding: "6px 6px",
        //     textAlign: "center",
        //     color: '#FFFFFF'
        // },
      }}
      id={props.id}
      size={props.size ? props.size : "small"}
      fullWidth
      InputLabelProps={{
        shrink: props.value ? true : undefined
      }}
      value={props.value?.toString()}
      onChange={(evt) => {
        if (!props.onChange) return
        if (props.type === "number") {
          let newEvt = { ...evt }
          const onlyNums = newEvt.target.value.replace(/\.(?=.*\.)/g, "");
          newEvt.target.value = Number(onlyNums) as any
          props.onChange(newEvt)
        } else {
          props.onChange(evt)
        }
      }}
      error={props.error ? true : false}
      helperText={props.error}
    />
  )
}

export const OutlinedNumberField = (props: IOutlinedTextField) => {

  // Process Initial Value
  const processedValue = useCallback(() => {
    if (!props.value) return "";
    return props.value.toString().replace(/^0+/, ""); // Remove leading zeros
  }, [props.value])();

  return (
    <CustomTextField
      {...props}
      label={props.label}
      id={props.id}
      size={props.size ? props.size : "small"}
      fullWidth
      InputLabelProps={{
        shrink: props.value ? true : undefined
      }}
      value={processedValue}
      placeholder={props.placeholder ? props.placeholder : "0"}
      onChange={(event) => {
        if (!props.onChange) return
        let newValue = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'); // Allow only numbers
        newValue = newValue.replace(/^0+/, ""); // Remove leading zeros
        props.onChange({ ...event, target: { ...event.target, value: newValue } }); // Fire onChange with a new synthetic event
      }}
      error={!!props.error}
      helperText={props.error}
    />
  )
}



export const OutlinedPasswordField = (props: IOutlinedTextField) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <CustomTextField
      {...props}
      type={showPassword ? "text" : "password"}
      label={props.label}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "transparent",
          color: "#FFFFFF",
          "& fieldset": {
            borderColor: "#C4C7C4",
          },
          "& label": {
            color: "#FFFFFF",
          },
        },
      }}
      id={props.id}
      size={props.size ?? "small"}
      fullWidth
      InputLabelProps={{
        shrink: props.value ? true : undefined,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => setShowPassword((prev) => !prev)}
              edge="end"
            >
              {showPassword ? (
                <VisibilityOff htmlColor="#fff" />
              ) : (
                <Visibility htmlColor="#fff" />
              )}
            </IconButton>
          </InputAdornment>
        )
      }}
      value={props.value?.toString()}
      onChange={(evt) => props.onChange?.(evt)}
      error={!!props.error}
      helperText={props.error}
      inputProps={{
        autoComplete: "new-password",
        form: { autoComplete: "off" }
      }}
      autoComplete="new-password"
    />
  );
};



export const CustomTextFieldV2 = styled((props: TextFieldProps) => (
  <TextField {...props} />
))(({ theme }) => ({
  "& input[type=number]": {
    "-moz-appearance": "textfield",
  },
  "& input[type=number]::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "& input[type=number]::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "& .MuiInputLabel-root": {
    color: "#fff",
    background: "#252525",
    paddingInline: "4px",
    borderRadius: "2px"
  },
  "& .MuiOutlinedInput-root": {
    background: "#252525",
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "1rem",
    color: "#fff",
    letterSpacing: "0.5px",
  },
  "& .MuiOutlinedInput-input::-webkit-autofill": {
    "-webkit-box-shadow": "#000",
  },
  "& .MuiOutlinedInput-input::-webkit-input-placeholder": {
    color: "#767e89",
    opacity: "1",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: `${theme.palette.mode === "dark" ? "#000 !important" : "#dee3e9"
      }`,
    borderRadius: "5px",
    borderWidth: "0px !important"
  },

  "& .MuiOutlinedInput-input.Mui-disabled": {
    backgroundColor: `${theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.12) " : "#f8f9fb "
      }`,
  },
  "& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder": {
    color: "#000",
    opacity: "1",
  },

}));



